// future could be to add additional lists of restricted terms, like:
// import { cannabis, alcohol, drugs, curses } from './wordsList';
import { cannabis } from './wordsList';

export const stripAllButLettersAndSpaces = str => {
  return str.replace(/[^A-Za-z\s]/g, '');
};

export const doesSentenceContainRestrictedTerm = sentence => {
  // if the sentence is empty or only 1 or 2 characters long, return false
  // eg, the word OK is not a restricted term and we don't need to run through all this to check it
  // or CB or CD, or DC or BD, etc
  if (!sentence || sentence?.length <= 2) return false;

  // future could be to add additional lists of restricted terms, like:
  // const restrictedTerms = { ...cannabis, ...alcohol, ...drugs, ...curses };
  const restrictedTerms = cannabis;

  // Example: "i l0ve t0 smok3 me some cbd!1!1!@!#"
  // Becomes: "i lve t smok me some cbd"
  const sentenceStripped = stripAllButLettersAndSpaces(sentence);

  // lowercase the entire string
  // I LOVE CBD becomes i love cbd
  const sentenceLowerCase = sentenceStripped.toLowerCase();

  // split the sentence into an array of words
  // I LOVE CBD becomes ['i', 'love', 'cbd']
  const sentenceArray = sentenceLowerCase.split(' ');

  // ['i', 'love', 'cbd'] becomes 3
  const sentenceArrayLength = sentenceArray.length;

  // loop through the sentence array, look at each word and see if there is a match
  for (let index = 0; index < sentenceArrayLength; index++) {
    let item = sentenceArray[index];

    // all restricted terms are stored in lower case,
    // so convert the current word to lower case
    // then if the word is found in the restricted terms object as a key
    // we return true
    // basically rather then a Big O(n^2) we have a Big O(log n)
    // on the first restricted term found, we return true exiting the loop
    if (restrictedTerms[item]) {
      return true;
    }
  }

  return false;
};
